import React from 'react';
import {
  Typography,
} from '@npm-registry/eapteka-ui';
import Informer from "../Informer";
import {TypographyWeights} from "@npm-registry/eapteka-ui/lib/components/Typography/Typography";

const SelectionInformer = () => {
  const informerText = (<span>
    <div className='BannerRecipeInformer_Header'>
      <Typography variant='p3' weight={TypographyWeights.strong}>Подобрали товары по&nbsp;вашему электронному рецепту</Typography>
    </div>
    <Typography variant='p3'>Сообщаем о&nbsp;возможном наличии лекарств по&nbsp;более низкой цене. Можете ознакомиться с&nbsp;ними в&nbsp;каталоге</Typography>
  </span>);

  return (
    <div className='BannerRecipe_Root'>
      <Informer
        text={informerText}
      />
    </div>
  );
};

export default SelectionInformer;
